<template>
    <div>
        <h1>{{ $t("admin.adminNotificationCreate.header") }}</h1>
        <form id="search" @submit="createNotification">
            <label for="subject">{{ $t("admin.adminNotificationCreate.subject") }}: </label><input id="subject" name="subject" v-model="notificationData.subject"><br/>
            <label for="description">{{ $t("admin.adminNotificationCreate.description") }}: </label><textarea id="description" name="description" v-model="notificationData.description"></textarea><br/>
            <label>{{ $t("admin.adminNotificationCreate.date") }}: </label><date-picker v-model="notificationData.date" format="YYYY/MM/DD" value-type="format" type="date" v-bind:placeholder="$t('admin.adminNotificationCreate.placeholder')"></date-picker><br/>
            <label for="enabled">{{ $t("admin.adminNotificationCreate.enabled") }}: </label><input id="enabled" name="enabled" v-model="notificationData.enabled" type="checkbox"><br/>

            <input type="submit" class="submit" v-bind:value="$t('admin.adminNotificationCreate.button.create')">
        </form>
        <hr>
        <h2>{{ $t("admin.adminNotificationCreate.review") }}</h2>
        <h3>{{ this.notificationData.date }}</h3>
        <h2>{{ this.notificationData.subject }}</h2>
        <p v-html="this.notificationData.description"></p>
    </div>
</template>

<script>
    import {adminService} from '@/services/admin.service'
    import DatePicker from 'vue2-datepicker'
    import 'vue2-datepicker/locale/ja';

    export default {
        name: 'AdminNotificationCreate',
        components: {
            DatePicker
        },
        data: function () {
            return {
            	notificationData: {
                    enabled: true
                }
            };
        },
        methods: {
            createNotification: function (e) {
                e.preventDefault();
                let tmpNotificationData = JSON.parse(JSON.stringify(this.notificationData));
                tmpNotificationData.description = btoa(encodeURIComponent(this.notificationData.description))
                adminService.notificationCreate(tmpNotificationData).then((notification) => {
                    console.log('Notification Created: ', notification);
                    this.$router.push('/admin/notificationView/' + notification.id);
                }).catch((err) => {
                    console.error('Unable to create notification: ', err)
                })
            }
        }
    }
</script>
